import React from "react";
import loadable from "utils/loadable";
import ClipLoader from "react-spinners/ClipLoader";
export default loadable(() => import("./index"), {
  // fallback: <LoadingIndicator />,
  fallback: (
    <div className="sweet-loading">
      <ClipLoader size={100} color={"#123abc"} loading={true} />
    </div>
  ),
});
